import FormattedMessage from 'I18n/components/FormattedMessage';
import { SprocketIcon } from 'foundations-assets/icons/components/SprocketIcon';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { H2 } from 'foundations-components/transitional/components/H2';
import { ToolRecommendationsForLearningContent } from '../ToolRecommendationsForLearningContent';
import { useGetToolRecommendations } from '../../queries/softwareDiscoveryHooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ShortContentFullToolRecommendations = ({
  contentName,
  useCases
}) => {
  const toolRecommendations = useGetToolRecommendations(useCases);
  const {
    shortTitleKey = '',
    descriptionKey = ''
  } = toolRecommendations || {};
  if (!toolRecommendations) {
    return null;
  }
  return /*#__PURE__*/_jsx(View, {
    backgroundColor: "fill-tertiary-pressed",
    paddingBlockStart: "1400",
    paddingInline: "700",
    children: /*#__PURE__*/_jsx(ToolRecommendationsForLearningContent, {
      cardWidth: 250,
      contentName: contentName,
      flexGap: "1000",
      renderRecommendations: commonContent => {
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(View, {
            marginBlock: "500",
            children: /*#__PURE__*/_jsxs(Flex, {
              alignItems: "center",
              flexDirection: "column",
              justifyContent: "center",
              children: [/*#__PURE__*/_jsxs(Flex, {
                alignItems: "center",
                inlineSize: "100%",
                justifyContent: "space-between",
                children: [/*#__PURE__*/_jsx(View, {
                  inlineSize: "72px"
                }), /*#__PURE__*/_jsx(H2, {
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: shortTitleKey
                  })
                }), /*#__PURE__*/_jsx(SprocketIcon, {
                  color: "fill-brand-default",
                  size: "1100"
                })]
              }), /*#__PURE__*/_jsx(Text, {
                color: "text-core-default",
                textAlign: "center",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: descriptionKey
                })
              })]
            })
          }), /*#__PURE__*/_jsx(View, {
            marginBlock: "500",
            children: commonContent
          })]
        });
      },
      toolsToDisplay: 3,
      useCases: useCases
    })
  });
};
export default ShortContentFullToolRecommendations;